<template>
	<div>
		<table class="table tight">
			<thead>
				<tr>
					<th colspan="3">Andamento prelievi</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>Anno</th>
					<th>[MWh]</th>
					<th>Variazione</th>
				</tr>
				<tr v-for="(item, index) in years" :key="index">
					<th>{{ item.year }}</th>
					<td>{{ formatPrecision(item.value, 3) }}</td>
					<td v-if="index == 0" :rowspan="years.length" class="text-center" style="vertical-align: middle;">
						<template v-if="index == 0 && diff != null">
							<h3 class="nowrap"><span>{{ diffSign }}</span>{{ diff }}%</h3>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<p>* Variazione rispetto ad anno precedente</p>
	</div>
</template>
<script>
import utils from '../../../utilsMixin';

export default {
	name: "PrelieviTable",
	mixins: [utils],
	props: ['data', 'year'],
	created() {

	},
	computed: {
		years() {
			return this.data.filter(item => item.value != null).map(item => {
				return {
					year: item.year,
					value: item.value ? item.value / 1000 : 0
				}
			})
		},
		diff() { 
			const yearValue = this.years.find(item => item.year == this.year)
			const preYearValue = this.years.find(item => item.year == this.year - 1)

			if (!yearValue || !preYearValue || preYearValue.value == 0) {
				return null
			}

			return ((yearValue.value - preYearValue.value) / preYearValue.value * 100).toFixed(2)
		},
		diffSign() { 
			if(this.diff > 0) {
				return '+'
			}
			return ''
		}
	}
}
</script>
<style scoped>
.nowrap {
	white-space: nowrap;
}
.tight td,
.tight th {
	padding-bottom: 1px;
	padding-top: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/BillAudit/Tables/PrelieviTable.vue